<template>
  <CycleContentBlock v-if="isListContainerVisible" :contrast-color="!isTransparent">
    <template v-if="image && imageSrc && !hasEmptyImage" #image>
      <a v-if="imageLink" :href="imageLink">
        <img :src="imageSrc" :title="imageTitle" :alt="imageAlt" loading="lazy" />
      </a>
      <img :src="imageSrc" :title="imageTitle" :alt="imageAlt" loading="lazy" v-else />
    </template>
    <template v-if="hasTitle" #header>
      <CycleIcon v-if="hasHeaderIcon" :modifiers="[headerIcon]" hexagon />
      <CycleHeading :weight="headingWeight">{{ title }}</CycleHeading>
    </template>
    <template v-if="hasBodyText || hasList" #body>
      <CycleHtml v-if="hasBodyText" :html="bodyText" />
      <CycleList v-if="hasList" modifiers="flat">
        <CycleListItem v-for="listItem in listItems" :key="listItem.id">
          <CycleLinkIcon
            v-if="hasLink(listItem) && hasText(listItem) && hasIcon(listItem)"
            class="link link--icon"
            :modifiers="getIcon(listItem)"
            :href="getLinkHref(listItem)"
            :target="getLinkTarget(listItem)"
          >
            {{ getText(listItem) }}
          </CycleLinkIcon>
          <CycleLink
            v-else-if="hasLink(listItem) && hasText(listItem)"
            :href="getLinkHref(listItem)"
            :target="getLinkTarget(listItem)"
          >
            {{ getText(listItem) }}
          </CycleLink>
          <template v-else>
            <CycleIcon v-if="hasIcon(listItem)" class="icon--list" :icon="getIcon(listItem)" />
            <span v-if="hasText(listItem)">{{ getText(listItem) }}</span>
          </template>
        </CycleListItem>
      </CycleList>
    </template>
    <template v-if="hasFooterText || hasLinks" #footer>
      <CycleHtml v-if="hasFooterText" :html="footerText" />
      <template v-if="hasLinks">
        <CycleButtonLink
          v-for="(link, index) in links"
          :key="index"
          :href="link.href"
          :target="link.target"
          :modifiers="link.modifiers"
        >
          {{ link.title }}
        </CycleButtonLink>
      </template>
    </template>
  </CycleContentBlock>
</template>
<script setup>
import { defaultHeadingWeight } from '@/constants/Defaults'
const props = defineProps({
  fields: {
    type: Object,
    default: () => ({})
  }
})

const getText = (listItem) => listItem.fields?.text?.value
const hasText = (listItem) => getText(listItem)?.length > 0
const getIcon = (listItem) => listItem.fields?.icon?.value
const hasIcon = (listItem) => getIcon(listItem)?.length > 0
const getLinkHref = (listItem) => listItem.fields?.link?.value?.href
const getLinkTarget = (listItem) => listItem.fields?.link?.value?.target
const hasLink = (listItem) => getLinkHref(listItem)?.length > 0

const image = props.fields?.image?.value ?? {}
const imageLink = props.fields?.imageLink?.value?.href
const imageSrc = props.fields?.image?.value?.src
const imageAlt = props.fields?.image?.value?.alt
const imageTitle =
  props.fields?.image?.value?.title ||
  props.fields?.image?.value?.name ||
  props.fields?.image?.value?.alt ||
  ''

const title = props.fields?.heading?.value
const hasTitle = title?.length > 0
const bodyText = props.fields?.bodyText?.value
const hasBodyText = bodyText?.length > 0
const footerText = props.fields?.footerText?.value
const hasFooterText = footerText?.length > 0
const links = props.fields?.links?.value
const hasLinks = links?.length > 0
const listItems = props.fields?.listItems || []
const hasList = listItems?.length > 0
const isTransparent = props.fields?.isTransparent?.value
const headerIcon = props.fields?.icon?.value
const hasHeaderIcon = headerIcon?.length > 0
const isListContainerVisible = hasTitle || hasBodyText || hasList || hasFooterText
const headingWeight = Number.parseInt(props.fields?.weight?.value) || defaultHeadingWeight
</script>
